import {
  CURRENCY_ISO_CODE_LENGTH,
  CURRENCY_MAX_DESCRIPTION_LENGTH,
  ICurrency,
  ICurrencyData,
  ICurrencyFieldError,
  ICurrencyFieldErrorData,
  ICurrencyRate,
  ICurrencyRateData,
  ICurrencyRateFieldError,
  ICurrencyRateFieldErrorData
} from './currency.types';

export class Currency implements ICurrency {
  //TODO: LF-2021-04-29 - Add readonly to properties once
  // new approach is being used in throughout project
  id?: number;
  code: string;
  description: string;

  constructor(data: ICurrencyData) {
    if (data.id) {
      this.id = data.id;
    }

    this.code = data.code;
    this.description = data.description;
  }

  validate(): boolean {
    // ensure currency ISO code is valid
    if (!this.code || this.code.length != CURRENCY_ISO_CODE_LENGTH) {
      return false;
    }

    // ensure currency description is valid
    if (
      !this.description ||
      this.description.length > CURRENCY_MAX_DESCRIPTION_LENGTH
    ) {
      return false;
    }

    return true;
  }
}

export class CurrencyRate implements ICurrencyRate {
  id?: number;
  currency?: ICurrency | number;
  owner?: string;
  rate?: number;
  created_at?: string | Date;

  constructor(data?: ICurrencyRateData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.currency) {
        this.currency =
          typeof data.currency === 'number'
            ? data.currency
            : new Currency(data.currency);
      }

      this.owner = data.owner ?? '';
      this.rate = Number(data.rate ?? 0);
      this.created_at = data.created_at;
    }
  }
}

export class CurrencyFieldError implements ICurrencyFieldError {
  code: string[] = [];
  description: string[] = [];

  constructor(data?: ICurrencyFieldErrorData) {
    if (data) {
      if (data.description) {
        this.description = data.description;
      }
      if (data.code) {
        this.code = data.code;
      }
    }
  }

  clearErrors(): void {
    this.description.splice(0, this.description.length);
    this.code.splice(0, this.code.length);
  }

  static isCurrencyFieldError(data: ICurrencyFieldErrorData): boolean {
    if (data.description && Array.isArray(data.description)) {
      return true;
    }
    if (data.code && Array.isArray(data.code)) {
      return true;
    }
    return false;
  }
}

export class CurrencyRateFieldError implements ICurrencyRateFieldError {
  rate: string[] = [];
  currency: ICurrencyFieldError = new CurrencyFieldError();

  constructor(data?: ICurrencyRateFieldErrorData) {
    if (data) {
      if (data.currency) {
        this.currency = new CurrencyFieldError(data.currency);
      }
      if (data.rate) {
        this.rate = data.rate;
      }
    }
  }

  clearErrors(): void {
    this.rate.splice(0, this.rate.length);
    this.currency.clearErrors();
  }

  static isCurrencyRateFieldError(data: ICurrencyRateFieldErrorData): boolean {
    if (
      data.currency &&
      CurrencyFieldError.isCurrencyFieldError(data.currency)
    ) {
      return true;
    }
    if (data.rate && Array.isArray(data.rate)) {
      return true;
    }
    return false;
  }
}
